import { render, staticRenderFns } from "./CertificatesListBox.vue?vue&type=template&id=52a6c3c3"
import script from "./CertificatesListBox.vue?vue&type=script&lang=js"
export * from "./CertificatesListBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports